module.exports = __webpack_public_path__ + "img/demo_food.568fdd3c.png";